import { DefineModule } from 'vuex';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  enabled: true,
  current: null,
  playing: false,
};

const storeModule: DefineModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    isAudioEnabled: (state) => state.enabled,
    isMusicPlaying: (state) => state.playing,
    currentMusic: (state) => state.current,
  },

  actions: {
    musicSet({ commit }, name) {
      commit('MUSIC_SET', name);
    },
    musicPlay({ commit }, name) {
      commit('MUSIC_PLAY', name);
    },
    musicPause({ commit }) {
      commit('MUSIC_PAUSE', undefined);
    },
    musicStop({ commit }) {
      commit('MUSIC_STOP', undefined);
    },
  },

  mutations: {
    AUDIO_DISABLED(state) {
      state.enabled = false;
    },
    MUSIC_SET(state, name) {
      state.current = name;
    },
    MUSIC_PLAY(state, name) {
      state.current = name;
      state.playing = true;
    },
    MUSIC_PAUSE(state) {
      state.playing = false;
    },
    MUSIC_STOP(state) {
      state.current = null;
      state.playing = false;
    },
  },
};

export default storeModule;
